<template>
    <div class="wte-section position-relative overflow-hidden">
        <svg class="wte-bubbles position-absolute" ref="bubbles" xmlns="http://www.w3.org/2000/svg" style="top:0;left:0;width:100%;height:100%;" preserveAspectRatio="xMidYMid slice" viewBox="0 0 1440 700">
            <!-- small dots -->
            <circle cx="35"   cy="30"  r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="195"  cy="25"  r="5"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="430"  cy="38"  r="4"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="590"  cy="32"  r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="750"  cy="28"  r="4"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="910"  cy="35"  r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="1150" cy="28"  r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="1390" cy="34"  r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="60"   cy="160" r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="305"  cy="205" r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="545"  cy="162" r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="705"  cy="155" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="865"  cy="158" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="1265" cy="205" r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="1420" cy="195" r="4"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="295"  cy="325" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="695"  cy="272" r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="1095" cy="322" r="4"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="1415" cy="318" r="5"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="155"  cy="450" r="4"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="560"  cy="402" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="960"  cy="448" r="4"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="1360" cy="408" r="5"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="298"  cy="572" r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="698"  cy="530" r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="1098" cy="578" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="170"  cy="685" r="4"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="582"  cy="642" r="5"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="982"  cy="688" r="4"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="1382" cy="648" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <!-- medium dots -->
            <circle cx="120"  cy="75"  r="10" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="350"  cy="35"  r="9"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="510"  cy="28"  r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="670"  cy="32"  r="9"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="830"  cy="22"  r="10" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="990"  cy="38"  r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="1230" cy="75"  r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="1310" cy="35"  r="10" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="145"  cy="200" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="385"  cy="148" r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="625"  cy="198" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="785"  cy="202" r="10" fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="1025" cy="150" r="11" fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="1185" cy="155" r="9"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="1345" cy="162" r="10" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="130"  cy="330" r="11" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="375"  cy="282" r="9"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="615"  cy="325" r="10" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="775"  cy="318" r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="1015" cy="275" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="1175" cy="278" r="10" fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="1335" cy="282" r="11" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="320"  cy="448" r="9"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="480"  cy="452" r="10" fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="720"  cy="405" r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="1040" cy="408" r="9"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="1280" cy="445" r="10" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="1430" cy="450" r="11" fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="45"   cy="530" r="9"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="378"  cy="530" r="10" fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="618"  cy="572" r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="858"  cy="528" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="1178" cy="530" r="10" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="1418" cy="575" r="11" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="255"  cy="645" r="9"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="420"  cy="648" r="10" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="662"  cy="685" r="11" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="822"  cy="682" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="1062" cy="648" r="10" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="1222" cy="645" r="11" fill="var(--atlas-yellow)"  opacity="0.35"/>
            <!-- mobile-band dots (cx 580–860, visible on narrow screens) -->
            <g class="mobile-dots">
            <!-- small -->
            <circle cx="612"  cy="45"  r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="648"  cy="118" r="5"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="688"  cy="62"  r="4"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="724"  cy="140" r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="760"  cy="55"  r="4"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="796"  cy="125" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="832"  cy="48"  r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="598"  cy="230" r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="636"  cy="260" r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="674"  cy="238" r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="712"  cy="295" r="4"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="750"  cy="248" r="5"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="788"  cy="268" r="4"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="826"  cy="235" r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="860"  cy="285" r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="590"  cy="370" r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="628"  cy="395" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="666"  cy="350" r="5"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="704"  cy="378" r="4"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="742"  cy="355" r="5"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="780"  cy="392" r="4"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="818"  cy="362" r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="856"  cy="388" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="600"  cy="470" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="640"  cy="495" r="4"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="680"  cy="475" r="5"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="720"  cy="510" r="4"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="760"  cy="482" r="5"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="800"  cy="498" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="840"  cy="472" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="610"  cy="598" r="4"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="650"  cy="622" r="5"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="690"  cy="605" r="4"  fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="730"  cy="638" r="5"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="770"  cy="612" r="4"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="810"  cy="628" r="5"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="850"  cy="600" r="4"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <!-- medium -->
            <circle cx="600"  cy="105" r="9"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="660"  cy="88"  r="10" fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="720"  cy="112" r="9"  fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="780"  cy="92"  r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="840"  cy="108" r="9"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="588"  cy="302" r="10" fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="648"  cy="318" r="9"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="708"  cy="295" r="11" fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="768"  cy="312" r="9"  fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="828"  cy="298" r="10" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="596"  cy="432" r="11" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="656"  cy="448" r="9"  fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="716"  cy="435" r="10" fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="776"  cy="452" r="11" fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="836"  cy="438" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="592"  cy="558" r="10" fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="652"  cy="542" r="11" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="712"  cy="562" r="9"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="772"  cy="548" r="10" fill="var(--atlas-orange)"  opacity="0.35"/>
            <circle cx="832"  cy="558" r="11" fill="var(--atlas-magenta)" opacity="0.35"/>
            <circle cx="608"  cy="668" r="9"  fill="var(--atlas-red)"     opacity="0.35"/>
            <circle cx="668"  cy="652" r="10" fill="var(--atlas-yellow)"  opacity="0.35"/>
            <circle cx="728"  cy="672" r="11" fill="var(--atlas-green)"   opacity="0.35"/>
            <circle cx="788"  cy="658" r="9"  fill="var(--atlas-blue)"    opacity="0.35"/>
            <circle cx="848"  cy="665" r="10" fill="var(--atlas-orange)"  opacity="0.35"/>
            <!-- large -->
            <circle cx="620"  cy="165" r="22" fill="var(--atlas-orange)"  opacity="0.25"/>
            <circle cx="720"  cy="172" r="18" fill="var(--atlas-blue)"    opacity="0.25"/>
            <circle cx="820"  cy="158" r="20" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="660"  cy="365" r="24" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="760"  cy="375" r="18" fill="var(--atlas-red)"     opacity="0.25"/>
            <circle cx="840"  cy="352" r="22" fill="var(--atlas-yellow)"  opacity="0.25"/>
            <circle cx="600"  cy="520" r="20" fill="var(--atlas-blue)"    opacity="0.25"/>
            <circle cx="700"  cy="508" r="24" fill="var(--atlas-orange)"  opacity="0.25"/>
            <circle cx="800"  cy="522" r="18" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="630"  cy="695" r="22" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="730"  cy="688" r="20" fill="var(--atlas-red)"     opacity="0.25"/>
            <circle cx="830"  cy="692" r="18" fill="var(--atlas-yellow)"  opacity="0.25"/>
            </g>
            <!-- large dots -->
            <circle cx="270"  cy="80"  r="20" fill="var(--atlas-red)"     opacity="0.25"/>
            <circle cx="840"  cy="140" r="24" fill="var(--atlas-orange)"  opacity="0.25"/>
            <circle cx="1070" cy="88"  r="18" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="225"  cy="155" r="22" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="945"  cy="195" r="26" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="1105" cy="200" r="18" fill="var(--atlas-red)"     opacity="0.25"/>
            <circle cx="40"   cy="280" r="20" fill="var(--atlas-red)"     opacity="0.25"/>
            <circle cx="455"  cy="320" r="24" fill="var(--atlas-yellow)"  opacity="0.25"/>
            <circle cx="855"  cy="280" r="22" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="1255" cy="325" r="18" fill="var(--atlas-blue)"    opacity="0.25"/>
            <circle cx="70"   cy="405" r="26" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="640"  cy="445" r="20" fill="var(--atlas-orange)"  opacity="0.25"/>
            <circle cx="800"  cy="452" r="24" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="1120" cy="452" r="18" fill="var(--atlas-orange)"  opacity="0.25"/>
            <circle cx="130"  cy="575" r="22" fill="var(--atlas-blue)"    opacity="0.25"/>
            <circle cx="458"  cy="578" r="26" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="778"  cy="575" r="20" fill="var(--atlas-yellow)"  opacity="0.25"/>
            <circle cx="938"  cy="572" r="18" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="1258" cy="572" r="24" fill="var(--atlas-yellow)"  opacity="0.25"/>
            <circle cx="80"   cy="648" r="22" fill="var(--atlas-blue)"    opacity="0.25"/>
            <circle cx="338"  cy="682" r="20" fill="var(--atlas-red)"     opacity="0.25"/>
            <circle cx="742"  cy="648" r="26" fill="var(--atlas-yellow)"  opacity="0.25"/>
            <circle cx="902"  cy="645" r="18" fill="var(--atlas-magenta)" opacity="0.25"/>
            <circle cx="1142" cy="682" r="22" fill="var(--atlas-green)"   opacity="0.25"/>
            <circle cx="1302" cy="688" r="24" fill="var(--atlas-red)"     opacity="0.25"/>
        </svg>
        <div class="position-relative" style="z-index:2;">
            <div class="px-4 px-lg-5 pt-5 text-center">
                <div class="text-uppercase oswald-bold text-white mb-4" style="font-size: clamp(2rem, 5vw, 3.5rem); letter-spacing: 2px; text-shadow: 0 2px 12px rgba(0,0,0,0.9), 0 0 30px rgba(0,0,0,0.7);">What to Expect</div>
            </div>
            <div class="row g-0 align-items-start px-4 px-lg-5 pb-5">
                <!-- Left: image -->
                <div class="col-12 col-xl-4 d-flex align-items-start justify-content-center pb-4 pb-xl-0" ref="wteImage">
                    <img src="@/assets/DUO.png" class="wte-image-side" :class="{ 'wte-image-visible': imageVisible }" alt="Atlas Improv performers" />
                </div>
                <!-- Right: cards -->
                <div class="col-12 col-xl-8 ps-xl-5">
                    <div class="wte-cards-grid" ref="cardsGrid">
                        <div v-for="(step, index) in steps" :key="step.title" class="wte-card-wrap" :class="{ 'wte-card-visible': cardsVisible }" :style="{ '--card-index': index }">
                            <div class="wte-card d-flex flex-column" :style="{ borderLeftColor: step.color, borderRightColor: step.color, borderBottomColor: step.color }">
                                <div class="d-flex justify-content-between align-items-start mb-3">
                                    <span class="text-uppercase oswald-bold" style="font-size: 1.45rem; letter-spacing: 1px;" :style="{ color: step.color }">{{ step.showSemester ? currentSemester + ' Classes' : step.title }}</span>
                                    <i :class="step.icon" :style="{ color: step.color }" style="font-size: 1.25rem; margin-left: 8px; flex-shrink: 0; margin-top: 2px;"></i>
                                </div>
                                <p v-if="step.showSemester" style="font-size: 1rem; color: #ddd; flex-grow: 1; margin-bottom: 0.6rem; line-height: 1.6;"><strong style="color:#eee;">{{ semesterInfo.label }}</strong><br>{{ semesterInfo.dates }}</p>
                                <p v-else-if="step.bodyHtml" v-html="step.bodyHtml" style="font-size: 1rem; color: #ddd; flex-grow: 1; margin-bottom: 0.6rem; line-height: 1.6;"></p>
                                <p v-else style="font-size: 1rem; color: #ddd; flex-grow: 1; margin-bottom: 0.6rem; line-height: 1.6;">{{ step.body }}</p>
                                <div v-if="step.buttons && step.buttons.length" class="d-flex flex-wrap gap-2 mt-auto">
                                    <template v-for="btn in step.buttons" :key="btn.text">
                                        <button v-if="btn.modal" @click="btn.modal()" class="wte-btn" :style="{ backgroundColor: step.color }">
                                            <i v-if="btn.icon" :class="btn.icon" class="me-1" style="font-size: 0.85rem;"></i>{{ btn.text }}
                                        </button>
                                        <a v-else :href="btn.href" class="wte-btn" :style="{ backgroundColor: step.color }">
                                            <i v-if="btn.icon" :class="btn.icon" class="me-1" style="font-size: 0.85rem;"></i>{{ btn.text }}
                                        </a>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wte-divider"></div>

        <!-- Parking Map Modal -->
        <transition name="md-superscale">
        <div v-if="showParkingMap" class="parking-modal-overlay" @click.self="showParkingMap = false">
            <div class="parking-modal-inner">
                <button class="parking-modal-close" @click="showParkingMap = false">&times;</button>
                <img :src="`${$API_ASSETS}9575146c-0de7-462b-bcde-040e373996b1.png`" class="img-fluid" alt="Parking Map" />
            </div>
        </div>
        </transition>

        <!-- Class Schedule Modal -->
        <transition name="md-superscale">
        <div v-if="showClassSchedule" class="parking-modal-overlay" @click.self="showClassSchedule = false">
            <div class="parking-modal-inner schedule-modal-inner">
                <button class="parking-modal-close" @click="showClassSchedule = false">&times;</button>
                <div class="schedule-modal-body">
                    <div class="text-uppercase oswald-bold text-center mb-4" style="font-size: 1.6rem; letter-spacing: 1px;">{{ currentSemester }} Classes</div>
                    <div v-for="row in classScheduleRows" :key="row.day + row.name" class="schedule-row">
                        <div class="schedule-time">
                            <span class="schedule-day">{{ row.day }}</span>
                            <span class="schedule-starts">{{ row.starts }}</span>
                        </div>
                        <div class="schedule-name-wrap">
                            <div class="schedule-name">{{ row.name }}</div>
                            <a v-if="row.link" :href="row.link" class="schedule-register">Register</a>
                        </div>
                        <div class="schedule-divider"></div>
                    </div>
                </div>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'WhatToExpect',
    created() {
        this.fetchSectionData();
    },
    mounted() {
        // Card scroll-in animation
        this._observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.cardsVisible = true;
                this._observer.disconnect();
            }
        }, { threshold: 0 });
        this._observer.observe(this.$el);

        this._imageObserver = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                this.imageVisible = true;
                this._imageObserver.disconnect();
            }
        }, { threshold: 0 });
        this._imageObserver.observe(this.$el);

        this._raf = null;
        this._onScroll = () => {
            if (this._raf) return;
            this._raf = requestAnimationFrame(() => {
                this._raf = null;
                if (!this.$refs.bubbles) return;
                const rect = this.$el.getBoundingClientRect();
                const offset = Math.min(0, rect.top * 0.06);
                this.$refs.bubbles.style.transform = `translateY(${offset}px)`;
            });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this._onScroll);
        if (this._raf) cancelAnimationFrame(this._raf);
        if (this._observer) this._observer.disconnect();
        if (this._imageObserver) this._imageObserver.disconnect();
    },
    data() {
        return {
            cardsVisible: false,
            imageVisible: false,
            showParkingMap: false,
            showClassSchedule: false,
            sectionData: [],
            steps: [
                {
                    title: 'Register',
                    color: '#1994AC',
                    icon: 'fas fa-laptop',
                    body: 'Sign up online before class fills up. All students new to Atlas start in Core. Discounts available for students, educators, active military, and veterans.',
                    buttons: [{ text: 'Register Now', href: this.$CLASS_URL, icon: 'fas fa-ticket-alt' }]
                },
                {
                    title: 'Find Us',
                    color: '#D8BA60',
                    icon: 'fas fa-map-marker-alt',
                    body: 'All classes meet at 609 E Washington Ave, Madison, WI 53703. Street parking and a ramp are nearby.',
                    buttons: [
                        { text: 'Get Directions', href: 'https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703', icon: 'fas fa-map-marker-alt' },
                        { text: 'Parking Map', modal: () => { this.showParkingMap = true; }, icon: 'fas fa-parking' }
                    ]
                },
                {
                    title: 'What to Wear',
                    color: '#D75948',
                    icon: 'fas fa-tshirt',
                    body: 'Come dressed comfortably. You will be moving and playing games, so dress to move freely. Closed-toed shoes are required for all classes.',
                    buttons: []
                },
                {
                    title: 'First Class',
                    color: '#017B4A',
                    icon: 'fas fa-star',
                    body: 'Expect warmup games, foundational exercises, and a lot of laughs. No experience required.',
                    buttons: [{ text: 'Class Agreement', href: '/ClassAgreement.pdf', icon: 'fas fa-file-alt' }]
                },
                {
                    title: 'Class Schedule',
                    color: '#BB4A8C',
                    icon: 'fas fa-calendar-alt',
                    showSemester: true,
                    buttons: [{ text: 'View Schedule', modal: () => { this.showClassSchedule = true; }, icon: 'fas fa-clock' }]
                },
                {
                    title: 'Questions?',
                    color: '#1994AC',
                    icon: 'fas fa-envelope',
                    body: 'Our education team is happy to help with any questions about classes, registration, or accommodations.',
                    buttons: [{ text: 'Email Us', href: 'mailto:edu@atlasimprov.com', icon: 'fas fa-envelope' }]
                },
            ]
        };
    },
    computed: {
        currentSemester() {
            // Pinned to the Spring term (class_session in Directus holds the Spring dates).
            // Previously this auto-detected the season by date — Spring (Nov 1–Mar 24),
            // Summer (Mar 25–Jul 24), Fall (Jul 25–Oct 31). Restore that logic here to
            // make it switch automatically again.
            return 'Spring';
        },
        semesterInfo() {
            const map = {
                Spring: { label: 'Spring Semester', dates: 'Class begins mid February' },
                Summer: { label: 'Summer Semester', dates: 'Begins late May (registration opens late April)' },
                Fall:   { label: 'Fall Semester',   dates: 'Class begins in late September (Registration Open Now!)' },
            };
            return map[this.currentSemester];
        },
        classScheduleRows() {
            return this.sectionData.map(s => ({
                day: `${this.getDayOfWeek(s.start_dt)}s ${this.format12HourTime(s.start_dt)}`,
                starts: `Starts ${this.getMonthDayOrdinal(s.start_dt)}`,
                name: s.course.name,
                link: s.course.link
            }));
        }
    },
    methods: {
        getDayOfWeek(start_dt) {
            return new Date(start_dt).toLocaleDateString('en-US', { weekday: 'long' });
        },
        getMonthDay(start_dt) {
            return new Date(start_dt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        },
        getMonthDayOrdinal(start_dt) {
            const date = new Date(start_dt);
            const month = date.toLocaleDateString('en-US', { month: 'short' });
            const d = date.getDate();
            const suffix = (d % 10 === 1 && d !== 11) ? 'st'
                : (d % 10 === 2 && d !== 12) ? 'nd'
                : (d % 10 === 3 && d !== 13) ? 'rd' : 'th';
            return `${month} ${d}${suffix}`;
        },
        format12HourTime(isoString) {
            const date = new Date(isoString);
            const hours = date.getHours() % 12 || 12;
            return `${hours} - ${hours + 2} pm`;
        },
        async fetchSectionData() {
            try {
                const response = await axios.post(this.$API_GRAPHQL, {
                    query: `query {
                        courseSection: class_session {
                            id
                            start_dt
                            course: class_id { id name link }
                        }
                    }`
                }, {
                    headers: {
                        'Authorization': `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
                        'Content-Type': 'application/json'
                    }
                });
                this.sectionData = (response.data.data.courseSection || [])
                    .sort((a, b) => new Date(a.start_dt) - new Date(b.start_dt));
            } catch (e) {
                console.error('Error fetching section data:', e);
            }
        }
    }
};
</script>

<style scoped>
.wte-section {
    background-color: var(--site-black);
}

.wte-divider {
    height: 2px;
    width: 100%;
    position: relative;
    z-index: 3;
    background-color: white;
}

.wte-bubbles {
    pointer-events: none;
    will-change: transform;
}

.mobile-dots {
    display: none;
}

@media (max-width: 575px) {
    .mobile-dots {
        display: block;
    }
}

.wte-image-side {
    max-height: 680px;
    width: 100%;
    margin-top: -2rem;
    object-fit: contain;
    opacity: 0;
    transform: translateX(-48px);
    transition: opacity 1.0s ease, transform 1.0s ease;
}

.wte-image-side.wte-image-visible {
    opacity: 1;
    transform: translateX(0);
}

/* Tablet: image stacks above cards — constrain so it doesn't span full width */
@media (min-width: 576px) and (max-width: 1199px) {
    .wte-image-side {
        max-width: 50%;
        max-height: 420px;
    }
}

@media (min-width: 1200px) {
    .wte-image-side {
        max-height: 860px;
    }
}

.wte-cards-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: 1fr;
    gap: 1rem;
}

@media (max-width: 575px) {
    .wte-cards-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .wte-cards-grid > div:nth-child(even) .wte-card {
        border-left: none;
        border-right-width: 3px;
        border-right-style: solid;
    }
}

.wte-card-wrap {
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 0.5s ease, transform 0.5s ease;
    transition-delay: calc(var(--card-index) * 0.1s);
}

.wte-card-wrap.wte-card-visible {
    opacity: 1;
    transform: translateY(0);
}

.wte-card {
    height: 100%;
    background-color: rgba(15, 15, 15, 0.82);
    border-left: 3px solid;
    padding: 1.2rem 1.1rem;
}

.wte-card p {
    font-family: 'Open Sans', sans-serif;
}

.wte-btn {
    display: inline-flex;
    align-items: center;
    padding: 7px 18px;
    font-size: 0.88rem;
    font-weight: 700;
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    color: white !important;
    text-decoration: none;
    letter-spacing: 0.5px;
    border-radius: 2px;
    white-space: nowrap;
}

.wte-btn:hover {
    opacity: 0.8;
}

.parking-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
}

.parking-modal-inner {
    position: relative;
    max-width: 800px;
    width: 100%;
}

.parking-modal-close {
    position: absolute;
    top: -1rem;
    right: -1rem;
    background: var(--atlas-magenta);
    color: white;
    border: none;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    font-size: 1.2rem;
    line-height: 1;
    cursor: pointer;
    z-index: 1;
}

.schedule-modal-inner {
    background: #111;
    border-radius: 6px;
    padding: 2rem 2.5rem 1.5rem;
    max-width: 620px;
}

.schedule-modal-body {
    color: #eee;
}

.schedule-row {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.9rem 0.5rem;
}

.schedule-time {
    font-family: 'Work Sans', sans-serif;
    white-space: nowrap;
    min-width: 180px;
    display: flex;
    flex-direction: column;
}

.schedule-day {
    font-weight: 700;
    font-size: 1.05rem;
    color: #BB4A8C;
}

.schedule-starts {
    font-weight: 400;
    font-size: 0.8rem;
    color: var(--atlas-yellow);
    margin-top: 2px;
}

.schedule-name-wrap {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 0.75rem;
}

.schedule-name {
    font-family: 'Open Sans', sans-serif;
    font-size: 1.05rem;
    color: #ddd;
    flex: 1;
}

.schedule-register {
    display: inline-flex;
    align-items: center;
    font-family: 'Work Sans', sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #BB4A8C !important;
    text-decoration: none;
    white-space: nowrap;
    border: 1px solid #BB4A8C;
    padding: 2px 10px;
    border-radius: 2px;
    flex-shrink: 0;
}

.schedule-register:hover {
    background: #BB4A8C;
    color: #fff !important;
}

.schedule-divider {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: rgba(255,255,255,0.08);
}

.schedule-row:last-child .schedule-divider {
    display: none;
}

/* "Super Scaled" modal animation (Codrops ModalWindowEffects):
   overlay fades while the panel zooms from 2x down to normal — and reverses on close.
   Targets .parking-modal-inner so it applies to both the parking and schedule modals. */
.md-superscale-enter-active,
.md-superscale-leave-active {
    transition: opacity 0.45s ease;
}

.md-superscale-enter-active .parking-modal-inner,
.md-superscale-leave-active .parking-modal-inner {
    transition: transform 0.45s ease, opacity 0.45s ease;
}

.md-superscale-enter-from,
.md-superscale-leave-to {
    opacity: 0;
}

.md-superscale-enter-from .parking-modal-inner,
.md-superscale-leave-to .parking-modal-inner {
    transform: scale(2);
    opacity: 0;
}

@media (max-width: 575px) {
    .schedule-modal-inner {
        padding: 1.5rem 1.25rem 1rem;
    }

    /* Two lines per row on mobile:
       Line 1 = class name (left) + Register (right)
       Line 2 = day/time + start date, inline with a separator */
    .schedule-row {
        flex-direction: column;
        align-items: stretch;
        gap: 0.3rem;
        padding: 0.85rem 0.25rem;
    }

    /* Line 1 */
    .schedule-name-wrap {
        order: 1;
        flex-direction: row;
        align-items: center;
        gap: 0.75rem;
        width: 100%;
    }

    .schedule-name {
        font-size: 1.1rem;
        font-weight: 700;
        color: #fff;
    }

    .schedule-register {
        flex-shrink: 0;
    }

    /* Line 2 — day/time on the left, start date pushed to the right edge */
    .schedule-time {
        order: 2;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
        width: 100%;
        min-width: unset;
    }

    .schedule-day {
        font-size: 0.95rem;
    }

    .schedule-starts {
        margin-top: 0;
    }
}
</style>
